import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage, useIntl } from '../../util/reactIntl';
import { waitlistCountryOf, countryName } from '../../util/payoutCountries';

import css from './PayoutWaitlistNotice.module.css';

// Shown to photographers whose bank account is in a country we cannot pay out in yet.
// They cannot connect a payout account (and so cannot publish galleries) until that changes;
// we write to them when it does (server/api-util/payoutWaitlist.js).
const PayoutWaitlistNotice = () => {
  const intl = useIntl();
  const currentUser = useSelector(state => state.user.currentUser);
  const country = waitlistCountryOf(currentUser);
  if (!country) {
    return null;
  }
  return (
    <div className={css.root} role="note">
      <strong className={css.title}>
        <FormattedMessage id="PayoutWaitlistNotice.title" />
      </strong>
      <span>
        <FormattedMessage
          id="PayoutWaitlistNotice.text"
          values={{ country: countryName(country, intl.locale) }}
        />
      </span>
    </div>
  );
};

export default PayoutWaitlistNotice;
